import isEmpty from 'lodash/isEmpty';
import {generateSearchPath} from './boats';

export const locationIncompleteUrlRegion = (currentParams, rewrittenURL, listingLocation) => {
  let urlParams = {};
  if (!currentParams.country && currentParams.region) {
    return generateSearchPath(undefined, undefined, true);
  } else if (currentParams.country && currentParams.region){
    return rewrittenURL;
  }
  if (!currentParams.country || !currentParams.subdivision) {
    urlParams.country = listingLocation.country;
    urlParams.subdivision = listingLocation.subdivision;
    if (currentParams.city) {
      const cityParamArray = currentParams.city.split('-');
      cityParamArray.shift();
      urlParams.city = [cityParamArray.join('-')];
    }
  }
  if (!isEmpty(urlParams)) {
    rewrittenURL = generateSearchPath(urlParams);
  }
  return rewrittenURL;
};

export const locationIncompleteUrlSubdivision = (currentParams, rewrittenURL, listingLocation) => {
  let urlParams = {};
  if (!currentParams.country || !currentParams.subdivision) {
    urlParams.country = listingLocation.country;
    urlParams.subdivision = listingLocation.subdivision;
    if (currentParams.city) {
      const cityParamArray = currentParams.city.split('-');
      cityParamArray.shift();
      urlParams.city = [cityParamArray.join('-')];
    }
    rewrittenURL = generateSearchPath(urlParams);
  }
  return rewrittenURL;
};

export const locationIncompleteUrlCity = (currentParams, listingLocation) => {
  let urlParams = {};
  urlParams.country = listingLocation.country;
  const cityParamArray = currentParams.city.split('-');
  cityParamArray.shift();
  urlParams.city = [cityParamArray.join('-')];
  return generateSearchPath(urlParams);
};
